import React, { useEffect, useState } from "react";
import api from "../../../services/api";
import { VIEW_KEY_BY_REPORT_KEY } from "./reportColumnCatalog";

function renderCell(v) {
  if (v === null || v === undefined) return "";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

export default function ReportTemplatePreview({
  payload,
  filters,
  title,
  headerText,
}) {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await api.previewReportTemplate({
          payload,
          filters,
          limit: 50,
        });
        if (cancelled) return;
        setColumns(Array.isArray(res?.columns) ? res.columns : []);
        setRows(Array.isArray(res?.rows) ? res.rows : []);
      } catch {
        if (!cancelled) {
          setColumns([]);
          setRows([]);
          setError("Failed to load preview");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [JSON.stringify(payload), JSON.stringify(filters)]);

  const labels = payload?.columnLabels || {};
  const displayLabel = (c) => {
    const vk = VIEW_KEY_BY_REPORT_KEY[c.key];
    return (vk && labels[vk]) || c.label;
  };

  return (
    <div className="r6-tpl-preview">
      <div className="r6-tpl-preview-head">
        <i className="fas fa-eye" />
        <span>Live preview</span>
        <span className="r6-tpl-preview-count">
          {loading ? "…" : `${rows.length} row${rows.length === 1 ? "" : "s"}`}
        </span>
      </div>

      {error && (
        <div className="error-message" role="alert">
          <i className="fas fa-exclamation-circle" /> {error}
        </div>
      )}

      {(title || headerText) && (
        <div className="r6-tpl-preview-banner">
          {title && <div className="r6-tpl-preview-title">{title}</div>}
          {headerText && (
            <div className="r6-tpl-preview-sub">{headerText}</div>
          )}
        </div>
      )}

      {loading ? (
        <div className="r6-tpl-preview-empty">Loading…</div>
      ) : columns.length === 0 ? (
        <div className="r6-tpl-preview-empty">No columns selected.</div>
      ) : (
        <div className="r6-tpl-preview-table-wrap">
          <table className="r6-tpl-preview-table">
            <thead>
              <tr>
                {columns.map((c) => (
                  <th key={c.key}>{displayLabel(c)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="r6-tpl-preview-empty-cell"
                  >
                    No rows match the current filters.
                  </td>
                </tr>
              ) : (
                rows.map((r, i) => (
                  <tr key={i}>
                    {columns.map((c) => (
                      <td key={c.key}>{renderCell(r[c.key])}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}